
export const interviewCommunityDataProviderToken = 'interview-community-data-provider';

export const interviewLISDataProviderToken = 'interview-lis-data-provider';

export const interviewMedicaidDataProviderToken = 'interview-medicaid-data-provider';

export const interviewSNAPDataProviderToken = 'interview-snap-data-provider';

export const interviewVeteranDataProviderToken = 'interview-veteran-data-provider';

export const interviewSSIDataProviderToken = 'interview-ssi-data-provider';
export const interviewMemberAssessmentDataProviderToken = 'interview-member-assessment-data-provider';
